/**
 * Node customizado para coleta de dados do usuário
 * Design com ícone de input e tipo de dado esperado
 * Inclui toolbar flutuante ao selecionar
 */

import { Handle, Position, NodeProps } from '@xyflow/react';
import { Type, Hash, Mail, Phone, Calendar } from 'lucide-react';
import { FlowNodeData } from '@/types/flows';
import { FlowNodeToolbar } from './FlowNodeToolbar';

/**
 * Componente visual do node de input de dados
 */
export function InputNode({ data, id, selected }: NodeProps) {
  const nodeData = data as FlowNodeData;
  const dataType = nodeData.config?.data_type || 'text';
  const variableName = nodeData.config?.variable_name || 'variavel';
  const question = nodeData.config?.question || 'Pergunta não configurada';
  
  // Callbacks injetados via FlowCanvas
  const onEdit = (nodeData as any).onEdit;
  const onDuplicate = (nodeData as any).onDuplicate;
  const onDelete = (nodeData as any).onDelete;
  const onTestFromHere = (nodeData as any).onTestFromHere;
  
  // Define ícone baseado no tipo de dado
  const getIcon = () => {
    switch (dataType) {
      case 'number': return Hash;
      case 'email': return Mail;
      case 'phone': return Phone;
      case 'date': return Calendar;
      default: return Type;
    }
  };
  
  const Icon = getIcon();
  const preview = question.length > 50 ? question.substring(0, 50) + '...' : question;

  return (
    <div className="bg-card rounded-lg shadow-lg border-2 border-emerald-500 min-w-[200px] max-w-[250px]">
      {/* Toolbar flutuante */}
      <FlowNodeToolbar
        nodeId={id}
        nodeType={nodeData.type}
        onEdit={onEdit}
        onDuplicate={onDuplicate}
        onDelete={onDelete}
        onTestFromHere={onTestFromHere}
        isVisible={selected}
      />
      
      <Handle
        type="target"
        position={Position.Top}
        className="!bg-emerald-500 !w-3 !h-3"
      />
      
      <div className="p-3">
        <div className="flex items-center gap-2 mb-2">
          <div className="bg-emerald-500/10 text-emerald-600 p-2 rounded">
            <Icon className="h-4 w-4" />
          </div>
          <div className="flex-1">
            <div className="font-semibold text-sm text-foreground">
              {nodeData.config?.nickname || 'Coletar Dados'}
            </div>
          </div>
        </div>
        
        <div className="text-xs text-muted-foreground bg-muted/50 rounded p-2 mb-2">
          {preview}
        </div>
        
        <div className="flex items-center justify-between text-xs">
          <span className="text-muted-foreground">Variável:</span>
          <span className="font-mono bg-emerald-500/10 text-emerald-700 px-2 py-1 rounded">
            {variableName}
          </span>
        </div>
      </div>
      
      <Handle
        type="source"
        position={Position.Bottom}
        className="!bg-emerald-500 !w-3 !h-3"
      />
    </div>
  );
}
